import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
    selector: 'webstore-product-detail-overlay-shimmer',
    imports: [CommonModule],
    templateUrl: './product-detail-overlay-shimmer.component.html',
    styleUrls: ['./product-detail-overlay-shimmer.component.scss']
})
export class ProductDetailOverlayShimmerComponent {

}

